import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import DownChevron from '!svg-react-loader?!images-react-svg/icons_v2/chevron-down.svg';
import UpChevron from '!svg-react-loader?!images-react-svg/icons_v2/chevron-up.svg';

const FrequentlyAskedQuestion = ({ question, answer }) => {
  const [showAnswer, setShowAnswer] = useState(false);

  const Icon = showAnswer ? UpChevron : DownChevron;

  const answerClasses = classNames('text--body--small', 'faq-item__answer', {
    'faq-item__answer--hidden': !showAnswer,
  });

  const toggleAnswer = () => setShowAnswer(!showAnswer);

  return (
    <div className="faq-item">
      <h2 className="heading--small faq-item__question" onClick={toggleAnswer}>
        {question}
        <Icon />
      </h2>
      <div
        className={answerClasses}
        dangerouslySetInnerHTML={{ __html: answer }}
      />
    </div>
  );
};

FrequentlyAskedQuestion.propTypes = {
  answer: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
};

export default FrequentlyAskedQuestion;
